// @flow

import type {Location} from 'docs/data/location/Location';

export const locationIsVSCode = (location: $Shape<Location>) =>
  location.query?.parentOrigin === 'vscode-file://vscode-app';
